<template>
  <div class="tab">
    <div>
      <span @click="returnFun()">＜返回</span>
      <h4>促进处境不利儿童积极发展，我们在科研和实践的道路上</h4>
      <span>“我的家庭，他们一般都是很少会关心我的。爸爸妈妈很少会关心我的。”</span>
      <span>“家里需要爸爸的时候，爸爸不在比较会心里比较难受。”</span>
      <span>
        “因为我们家里的条件虽然说很稳定，但是不太好，然后平时都会有补助，我一直
        <br />想着把家里的生活给提上去，有这个动力然后学习好。”
      </span>
      <span>
        “家里是有一些贫困，然后在社会上因为如果没有打定基础，有可能不容易立足，
        <br />就想着在社会上能成功立足，有一个动力。”
      </span>
      <img src="../../assets/list2.png" alt />
      <span>心理弹性干预活动现场图</span>
      <p>根据民政部2018年发布的数据显示，全国共有农村留守儿童697万人，七成为义务教育阶段儿童。根据教育部2017年全国教育事业发展统计公报显示，我国义务教育阶段的流动儿童共计 1406.63 万人。庞大的处境不利儿童青少年群体引起了众多研究者的注意。</p>
      <p>大量研究结果表明，流动儿童在城市之中比城市儿童面临着更多压力，包括家庭经济收入低、教育资源少、歧视以及频繁的流动性等，这些压力和困境对他们的身心健康发展均带来了一定的影响。同时，留守经历带来的不利成长环境对儿童的影响也非常巨大，包括学习兴趣不高、主观幸福感和生活满意度偏低、情绪较不稳定以及较多的攻击行为和违纪行为等等。如何在处境不利的状况下激发儿童的个人资源和优势，从而获得积极发展，一直是我们多年来重点关注的内容。</p>
      <h5>一、流动儿童中的心理弹性干预</h5>
      <img src="../../assets/list2_1.png" alt />
      <span>流动儿童心理弹性干预活动合照</span>
      <p>我们的理念是，每个孩子都有其内在的积极资源和向上的力量。只要为其创设积极、支持性的环境和氛围，就能激发处境不利儿童在压力和逆境下的心理弹性，从而让他们获得同样甚至更好的发展。心理弹性视角可以帮助我们更好地解读并激发孩子内心的积极力量！心理弹性是指个体即使在面对重大压力、逆境和创伤，但仍然能应对良好或获得良好恢复的过程，基于心理弹性的干预是“病理取向” 转变为“积极取向” 的研究范式在干预领域的运用。心理弹性干预致力于提升那些身处逆境或遭遇重大压力与创伤的个体，这些个体虽然处于不利环境，但依然具有良好的适应和积极发展的潜能，能够凭借自身积极的品质和环境中的有利资源改善自身的心理状态。</p>
      <p>因此，我们将每个处境不利的群体都看作为有能力可以主动调动内外资源获得良好适应和发展的个体，并基于此重要且具创新性的视角在流动儿童、留守儿童和艾滋孤儿群体中分别开展了系列心理弹性干预研究，并收到了很好的效果。</p>
      <img src="../../assets/list2_2.png" alt />
      <span>流动儿童学校心理弹性干预活动的分享环节</span>
      <img src="../../assets/list2_3.png" alt />
      <span>流动儿童在心理弹性干预活动中与团体组长的积极互动</span>
      <p>2011-2017年中，我们多次在北京市打工子弟学校开展心理弹性干预研究。干预前后测对比发现，干预有效地提升了流动儿童与逆境有关的积极认知、与城市适应压力有关的自我效能感以及公平感，同时流动儿童的自尊与自我效能感也得到有效的提高。另外通过干预，孩子们更懂得如何欣赏和接纳自己，学会如何在逆境下积极地调整心态，应对压力和解决问题的能力均得到显著的提升。</p>
      <h5>二、留守儿童社区工作者中的心理弹性干预</h5>
      <p>2018年12月，我们对贵州省2个地级市2个自治州113个村的113名童伴妈妈集中进行了心理弹性干预课程培训，并从中选取了20名骨干人员进一步对600名留守儿童进行心理弹性干预。每名童伴妈妈从自己所负责的村中随机选取30名留守儿童（男女生比例各一半，涉及的年级包括小学3-6年级和初中1-2年级）实施6-8次的心理弹性干预活动。</p>
      <p>（这个部分中的具体内容，即童伴妈妈项目所有干预活动，请详见3 心理弹性项目培训项目）</p>
      <img src="../../assets/list2_4.png" alt />
      <span>心理弹性干预的“画一画阳光雨露”活动</span>
      <h5>三、艾滋孤儿心理弹性干预</h5>
      <p>研究发现，由父母或其他照料者所带来的早期抚养不利会对个体的身体、大脑、认知等方面带来长期的负面影响。我们在这个领域做了一些开创性的探索性研究，整合多学科之视角，探索了心理弹性干预对儿童青少年大脑功能结构的影响及其神经机制，更进一步深化了心理弹性干预在降低艾滋孤儿逆境的负面影响、提升个体心理健康水平方面的重要意义。2014年12月，我们选取了20名孤儿院的艾滋孤儿开展了为期12周的以情绪调节为核心的心理弹性干预活动，并首次从大脑功能结构和行为两个角度同时考察了干预对艾滋孤儿的作用与影响，我们旨在深入探究干预对早期抚养不利儿童大脑可塑性和行为可塑性的作用。结果显示，干预组的艾滋孤儿心理弹性在干预后得到了显著提升，其未来希望感在干预后的3个月内持续上升。同时，艾滋孤儿的静息态脑功能在心理弹性干预后发生明显变化，尤其右侧扣带回脑区的干预前后测fALFF值差异显著。进一步深入分析后，可以看出心理干预使艾滋孤儿在静息态下大脑自发活动强度更低，这种“波澜不惊”的平静状态能帮助个体有效地适应环境。</p>
      <img src="../../assets/list2_5.png" alt />
      <span>艾滋孤儿心理弹性干预活动中的小组交流</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "list2",
  data() {
    return {};
  },
  props: ["listOrCon"],
  methods:{
    returnFun(){
      this.$emit("returnPage")
    }
  }
};
</script>
<style scoped src="../../assets/style/grandchild.css">
/* @import '../assets/style/child.css'; */
</style>
<style scoped>
.tab > div {
  padding: 0;
}
.tab > div > span:first-child{
  cursor: pointer;
  display: inline-block;
  padding: 4px 10px;
  border-radius: 5px;
  color: #7ecef4;
  border: solid 1px #7ecef4
}
.tab > div > h4 {
  text-align: center;
  font-size: 24px;
}
.tab > div > h5 {
  text-align: center;
  margin: 30px 0;
  font-size: 20px;
}
.tab > div > img {
  margin: 20px 0;
}
.tab > div > span {
  display: block;
  text-align: center;
  font-size: 16px;
  line-height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/psychological/list2.vue